import Vue from "vue";

import BoardBasisListSelect from "../../shared/BoardBasisListSelect";
export default Vue.extend({
  template: `
  <div style="padding:15px;">
   <board-basis-list-select
                        v-model="boardBasis"
                        @change="onChange"
                      ></board-basis-list-select>
  </div>
    `,
  components: { BoardBasisListSelect },
  data: function () {
    return {
      boardBasis: "",
    };
  },

  mounted() {},

  methods: {
    onChange(payload) {
      console.log("boardBasis changed", payload);
      this.params.api.stopEditing();
    },
    getValue() {
      return this.boardBasis;
    },
    isPopup() {
      return true;
    },
  },
  beforeMount() {
    this.boardBasis = this.params.data.boardBasis;
  },
});



// WEBPACK FOOTER //
// ./src/components/gt/shared/ag-grid/AgGridBoardBasisEditor.js